/** @jsx jsx */
import { jsx, Box, Text } from 'theme-ui'
import { useState, useEffect } from 'react'
import Slider from "react-slick"
import { isMobile } from "react-device-detect";

const SampleNextArrow = ({onClick }) =>
  <Box
    onClick={onClick}
    sx={{
      display: isMobile && 'none',
      position: "absolute",
      width: "50%",
      height: "100%",
      top: 0,
      right: 0,
      zIndex: 1,
    }}
    css={{
      cursor: [`url(${ArrowRight}), e-resize`, `-webkit-image-set(url("/arrows/right.png") 1x, url("/arrows/right@2x.png") 2x) 0 0, e-resize`]
    }}
  />

function SamplePrevArrow({onClick }) {
  return (
    <Box onClick={onClick}
      sx={{
        display: isMobile && 'none',
        position: "absolute",
        width: "50%",
        height: "100%",
        top: 0,
        left: 0,
        zIndex: 1,
      }}
      css={{
        cursor: [`url(${ArrowLeft}), w-resize`, `-webkit-image-set(url("/arrows/left.png") 1x, url("/arrows/left@2x.png") 2x) 0 0, w-resize`]
      }}
    />
  );
}

const Slideshow = ({children, sx, altStyle,...props}) => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [isTransitioning, setIsTransitioning] = useState(false)
  const [alt, setAlt] = useState("")

  useEffect(() => {
    setAlt(children.length > 0 ? children[currentSlide].props.altText : children.props.altText)
  }, [currentSlide, children])

  const settings = {
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    beforeChange: () => {
      setIsTransitioning(true)
    },
    afterChange: current => {
      setCurrentSlide(current)
      setIsTransitioning(false)
    }
  }

  return (
    <Box sx={sx} {...props}>
      <Slider {...settings}>
        {children}
      </Slider>
      {alt !== undefined ? <Text as="p" sx={{transition: "all .3s ease-in", pr: 4, opacity: isTransitioning ? 0 : 1,...altStyle}}>{alt}</Text> : null}
    </Box>
  )
}

const ArrowLeft = () =>
  <svg width="28" height="22" viewBox="0 0 28 22" fill="#22201e" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.776 21.004C7.524 15.928 4.5 12.904 0 12.508V9.69999C4.5 9.30399 7.524 6.31599 7.776 1.23999L11.124 1.95999C10.944 3.79599 10.296 5.41599 9.216 6.89199C8.1 8.33199 6.84 9.26799 5.4 9.69999H27.998V12.508H5.4C6.84 12.94 8.1 13.876 9.216 15.352C10.296 16.828 10.944 18.448 11.124 20.248L7.776 21.004Z"/>
  </svg>

const ArrowRight = () =>
<svg width="28" height="22" viewBox="0 0 28 22" fill="#22201e" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.222 21.004C20.474 15.928 23.498 12.904 27.998 12.508V9.69999C23.498 9.30399 20.474 6.31599 20.222 1.23999L16.874 1.95999C17.054 3.79599 17.702 5.41599 18.782 6.89199C19.898 8.33199 21.158 9.26799 22.598 9.69999H0V12.508H22.598C21.158 12.94 19.898 13.876 18.782 15.352C17.702 16.828 17.054 18.448 16.874 20.248L20.222 21.004Z" />
  </svg>


export default Slideshow